export const INTAKE = {
  quickExit: "quick-exit-button",
  progress: "progress-indicator",
  // Stage 1
  triageOption: "triage-option",
  triageContinue: "triage-continue",
  emergencyPanel: "emergency-info-panel",
  urgentForm: "urgent-contact-form",
  urgentSubmit: "urgent-contact-submit",
  urgentContinue: "urgent-continue-full-form",
  urgentExit: "urgent-exit",
  // Stage 2
  fundingCheckbox: "private-funding-checkbox",
  fundingContinue: "funding-continue",
  // Stage 3
  contactContinue: "contact-continue",
  // Stage 4
  routeCard: "route-card",
  // Nav
  back: "step-back",
  backTop: "step-back-top",
  continue: "step-continue",
  submit: "enquiry-submit",
  saveReturn: "save-and-return",
  saveReturnEmail: "save-return-email",
  saveReturnSend: "save-return-send",
  // Confirmation
  confirmation: "confirmation-screen",
  reference: "enquiry-reference",
};
